import { baseUrlAtom } from "@/store/base_api";
import * as Sentry from "@sentry/react";
import { getDefaultStore } from "jotai";

export function initSentry() {
	if (!import.meta.env.VITE_APP_SENTRY_DSN) {
		console.error(
			"[sentry] VITE_APP_SENTRY_DSN is not set — errors will not be sent",
		);
		return;
	}
	const baseUrl = getDefaultStore().get(baseUrlAtom);
	const sentryOptions: Sentry.BrowserOptions = {
		initialScope: { tags: { app: "snipetransfer" } },
		release: import.meta.env.VITE_SENTRY_APP_RELEASE,
		dsn: import.meta.env.VITE_APP_SENTRY_DSN,
		environment: import.meta.env.MODE,
		integrations: [
			Sentry.extraErrorDataIntegration(),
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true,
			}),
		],
		tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1,
		tracePropagationTargets: [baseUrl], // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	};

	if (import.meta.env.DEV) {
		if (Array.isArray(sentryOptions.integrations))
			sentryOptions.integrations.push(Sentry.debugIntegration()); // console.log Sentry events
		sentryOptions.transport = (options) => {
			return Sentry.makeFetchTransport(
				options,
				async (_url, _init) => new Response(), // don't send request, just return a response
			);
		};
	}

	Sentry.init(sentryOptions);
}
